import React, { useState } from "react";
import '../styles/otplogin.css';
import bg from '../assets/images/login-bg.png';
import MobileNumber from "./inputs/MobileNumber";
import PrimaryButton from "./inputs/PrimaryButton";
import OTPEnter from "./OTPEnter";
import { showToast } from "../helpers/UIHelper";
import { Api } from "../api/Api";
import { Button, Checkbox, Modal } from "antd";
import { getLogo } from "../helpers/Helpers";
import TermsAndConditions from "./TermsAndConditions";
import PrivacyPolicy from "./PrivacyPolicy";

const OTPLogin = () => {
    const [sendingOtp, setSendingOtp] = useState(false);
    const [otpSent, setOtpSent] = useState(false);
    const [mobile, setMobile] = useState('');
    const [countTo, setCountTo] = useState(0);
    const [agreed, setAgreed] = useState(false);
    const [showTerms, setShowTerms] = useState(false);
    const [showPolicy, setShowPolicy] = useState(false);
    const sendOTP = () => {
        if (mobile === '') {
            showToast('error', 'Enter a valid mobile number.');
            return;
        }
        if (!agreed) {
            showToast('error', 'You must agree to the terms and conditions.');
            return;
        }
        setSendingOtp(true);
        Api.sendOTP(mobile.replaceAll('-',''))
            .then((resp) => {
                if (resp.status === 200) {
                    setCountTo(resp.data.validity);
                    setOtpSent(true);
                } else {
                    showToast('error', 'OTP Generation failed, Please check the entered mobile number.');
                }
                setSendingOtp(false);
            })
            .catch((e) => {
                console.log(e);
                showToast('error', e);
                setSendingOtp(false);
            });
    };
    return (
    <>
        {!otpSent ?
            <div className="otp-login-container">
                <div className="image-container">
                    <img src={bg} alt="login-bg"/>
                </div>
                <div className="text-container">
                    <div className="main-text">Enter Your Mobile Number</div>
                    <div className="sub-text">We will send you a confirmation code</div>
                </div>
                <div className="bottom-container">
                    <div className="form-container">
                        <MobileNumber value={mobile} onChange={setMobile} />
                    </div>
                    <div className="form-container">
                            <Checkbox checked={agreed} onChange={(e) => { setAgreed(e.target.checked) }}><span className="terms-text">I have read and agree to the </span><span onClick={() => { setShowTerms(true); setAgreed(false); }} className="terms">Terms and Conditions</span> and 
                                <span onClick={() => { setShowPolicy(true); }} className="terms"> all applicable policies.</span>
                            </Checkbox>
                    </div>
                    <div className="form-container">
                        <PrimaryButton label="Send Code" isLoading={sendingOtp} onClick={() => { sendOTP(); }} />
                    </div>
                </div>
                <div className="logo-container">
                    {getLogo()}
                </div>
                <Modal open={showTerms} closable={false} footer={null} title="Terms and conditions">
                    <TermsAndConditions/>
                    <div className="form-container">
                        <Button type="primary" style={{margin:'0 10px 0 0'}} onClick={() => { setAgreed(true); setShowTerms(false); }}>Agree</Button>
                        <Button style={{margin:'0 0 0 10px'}} onClick={() => { setAgreed(false); setShowTerms(false); }}>Disagree</Button>
                    </div>        
                </Modal>
                <Modal open={showPolicy} closable={false} footer={null} title="Applicable Policies">
                    <PrivacyPolicy/>
                    <div className="form-container">
                        <Button type="primary" style={{margin:'0 10px 0 0'}} onClick={() => { setShowPolicy(false); }}>Ok</Button>
                    </div>        
                </Modal>    
            </div > :
            <OTPEnter countTo={countTo} retry={() => { setOtpSent(false) }} mobile={mobile} />
        }
    </>
    )
}
export default OTPLogin;